import { Dictionary } from "../collection/Dictionary";
import { Logger } from "../log/Logger";
/**
 * EventBus.ts
 *
 * Holds a collection of functions to call depending on the EventObject type.
 */
export class EventBus {
    constructor() {
        this.modifiedTypes = [];
        this.handlers = new Dictionary();
    }
    /**
     * Any additions to addEventListeners() must also be added to removeEventListeners().
     */
    addEventListener(type, handler, scope) {
        let handlers;
        if (this.handlers.containsKey(type)) {
            handlers = this.handlers.getValue(type);
        }
        else {
            handlers = new Dictionary();
            this.handlers.setValue(type, handlers);
        }
        handlers.setValue(scope, handler.bind(scope));
        this.addModifiedType(type);
    }
    removeAllListeners() {
        this.handlers = new Dictionary();
    }
    removeEventListener(type, scope) {
        let handlers;
        if (this.handlers.containsKey(type)) {
            handlers = this.handlers.getValue(type);
            handlers.remove(scope);
            this.addModifiedType(type);
        }
    }
    removeEventListenersFor(scope) {
        let handlers = this.handlers.getValues();
        for (let handler of handlers) {
            if (handler.containsKey(scope)) {
                handler.remove(scope);
            }
        }
    }
    dispatchEvent(event) {
        Logger.verbose("EVENT: " + event.getType());
        let handlerSet;
        let type = event.getType();
        let proms = [];
        if (this.handlers.containsKey(type)) {
            handlerSet = this.handlers.getValue(type);
            let keys = handlerSet.getKeys();
            let dispatched = [];
            let dispatching = true;
            while (dispatching) {
                this.modifiedTypes = [];
                for (let i = 0; i < keys.length; i++) {
                    let key = keys[i];
                    if (!this.contains(dispatched, key)) {
                        let handler = handlerSet.getValue(key);
                        dispatched.push(key);
                        proms.push(handler.call(key, event));
                    }
                }
                dispatching = this.contains(this.modifiedTypes, type);
            }
        }
        return proms;
    }
    /**
     * Awaits all async event listeners for the given `event`.
     *
     * Most event listeners do not return promises so they resolve instantly.
     *
     * @param event - The event to dispatch.
     */
    async dispatchBlockingEvent(event) {
        Logger.verbose("BLOCKING EVENT");
        const dispatched = this.dispatchEvent(event);
        await Promise.all(dispatched);
    }
    addModifiedType(type) {
        if (!this.contains(this.modifiedTypes, type)) {
            this.modifiedTypes.push(type);
        }
    }
    /**
     * @deprecated Use `array.includes(object)`
     */
    contains(array, object) {
        return array.indexOf(object) >= 0;
    }
}
//# sourceMappingURL=EventBus.js.map